// Firebase Config
export const firebaseConfig = {
  projectId: process.env.REACT_APP_PROJECT_ID,
  apiKey: process.env.REACT_APP_API_KEY,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  cloudFunctionApiURL: process.env.REACT_APP_CLOUD_FUNCTION_API_URL,
  cloudFunctionPublicApiUrl: process.env.REACT_APP_CLOUD_FUNCTION_PUBLIC_API_URL,
};
